module.exports = ".hot-container {\n  width: 100%;\n  height: 600px;\n  overflow: hidden;\n  margin-top: 16px; }\n\n.spinner {\n  float: right; }\n"